// Shared top-level action button styles — the filled-blue-pill convention
// already used across the main app for a page's primary "+ Add X" trigger
// or Edit/Save toggle (e.g. Estimate.jsx's "+ Add to Estimate"/"+ New
// Alternate", Vendors.jsx's "Edit"/"Save Changes"). The Setup admin pages
// had drifted to plain unstyled <button> elements for their own "+ Add X"
// triggers instead of pulling this same convention, which is why they read
// as visually inconsistent with the rest of the app. One shared place to
// pull the real values from, instead of re-pasting the literal style object
// per page (which is how the drift happened in the first place).
//
// Deliberately NOT applied to a form's own inline Save/Cancel once it's
// open (e.g. the row-level "Save"/"Cancel" under an "+ Add Item" form) —
// that plain/minimal style is itself the established convention app-wide,
// including in Estimate.jsx's own alternate/line-item draft forms.
export const btnPrimary = {
  fontSize: 12, fontWeight: 600, padding: "5px 12px",
  background: "var(--cs-blue)", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer",
};
